export default __webpack_public_path__ + "static/media/subject-economics.68fcbbc4.webp";